import { apiSlice } from '../app/api/apiSlice';

export const eventAuxApi = apiSlice.injectEndpoints({
  endpoints: (builder)=>({
    getEventsAux: builder.mutation({
      query: (eventsIds)=>({
          url: 'Event/EventsByIds',
          method: 'post',
          body: eventsIds
        })
    }),
  })
})

export const { useGetEventsAuxMutation } = eventAuxApi;
